import type { JSX } from 'react'
import BrowseCreditApplicationsPage from '../BrowseCreditApplicationsPage'

const App = (): JSX.Element => {
  return <BrowseCreditApplicationsPage />
}

export default App
